<script>
import Component from '~/sites/oknanebodvere/pages/product/_slug'
import eventDefinitions from '@/events/eventDefinitions'
export default {
  extends: Component,
  nuxtI18n: {
    paths: {
      cs: '/produkt/:slug',
      de: '/produkt/:slug',
      en: '/product/:slug',
      sk: '/produkt/:slug',
    },
  },
  methods: {
    sendProductPageViewEvent() {
      const currentProductId = this.product?.id
      if (!currentProductId) return

      const lastSentId = localStorage.getItem('lastSentProductId')

      if (String(lastSentId) === String(currentProductId)) return
      localStorage.setItem('lastSentProductId', currentProductId)

      const colourCode = this.$route?.query?.barva
      const colourId = this.resolveColourId(colourCode)

      this.$eventBus.$emit(eventDefinitions.PRODUCT.PAGE_VIEW, {
        product: this.product,
        variant: this.displayedVariant,
        colour: colourId,
      })
    },
    resolveColourId(code) {
      const COLOR_MAP = {
        'bila_bila': '1',
        'zlaty_dub_zlaty_dub': '2',
        'orech_orech': '3',
        'anthrazitgrau_struktura_bila': '4',
      }
      return COLOR_MAP[code] || null
    },
  },
}
</script>
